var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Whatsapp from "./Whatsapp";
var SlideImageHome = /** @class */ (function (_super) {
    __extends(SlideImageHome, _super);
    function SlideImageHome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.image = '';
        _this.currentImage = 0;
        return _this;
    }
    SlideImageHome.prototype.beforeMount = function () {
        var _this = this;
        this.image = this.images[this.currentImage];
        setInterval(function () {
            _this.nextImage();
        }, 4500);
    };
    SlideImageHome.prototype.nextImage = function () {
        this.currentImage++;
        if (this.images.length <= this.currentImage) {
            this.currentImage = 0;
        }
        this.image = this.images[this.currentImage];
    };
    __decorate([
        Prop()
    ], SlideImageHome.prototype, "images", void 0);
    SlideImageHome = __decorate([
        Component({
            components: {
                Whatsapp: Whatsapp
            },
        })
    ], SlideImageHome);
    return SlideImageHome;
}(Vue));
export default SlideImageHome;
